class ProductFocusBlock extends HTMLElement {
  constructor() {
    super();

    const splideElement = this.querySelector(".splide");
    if (!splideElement) {
      return;
    }
    const isFull = splideElement.classList.contains("full");
    const splideId = splideElement.getAttribute("id");
    document.addEventListener("DOMContentLoaded", () => {
      this.splide = new Splide("#" + splideId, {
        perPage: 3,
        perMove: 1,
        updateOnMove: true,
        snap: true,
        drag: true,
        trimSpace: false,
        pagination: splideElement.hasAttribute("data-pagination")
          ? splideElement.getAttribute("data-pagination") == "false"
            ? false
            : true
          : false,
        arrows: false,
        flickPower: 100,
        flickMaxPages: 1,
        focus: 0,
        gap: isFull ? "1px" : "calc(var(--padding-sections-desktop) / 2)",
        padding: {
          right: isFull
            ? "calc(var(--padding-sections-desktop) * 5)"
            : "calc(var(--padding-sections-desktop) * 2)",
        },
        breakpoints: {
          1199: {
            perPage: 2,
            padding: {
              left: 0,
              right: "calc(var(--padding-sections-desktop) * 2)",
            },
          },
          549: {
            perPage: 1,
            padding: {
              left: isFull
                ? "var(--padding-sections-desktop)"
                : "calc(var(--padding-sections-desktop) * 2)",
              right: isFull
                ? "var(--padding-sections-desktop)"
                : "calc(var(--padding-sections-desktop) * 2)",
            },
          },
        },
      });

      this.splide.mount();

      this.splide.on("move", (newIndex) => {
        this.onSlideMove(newIndex);
      });

      this.splide.on("click", (slide) => {
        this.splide.go(slide.index);
        const video = slide.slide.querySelector("video");
        if (video) {
          video.play();
        }
      });

      this.splide.on("active", (slide) => {
        const video = slide.slide.querySelector("video");
        if (video) {
          video.play();
        }
      });

      this.splide.on("inactive", (slide) => {
        const videos = slide.slide.querySelectorAll("video");
        if (videos.length) {
          videos.forEach((video) => {
            video.pause();
          });
        }
      });

      //Behavior for videos
      const videos = this.querySelectorAll("video");
      videos.forEach((video) => {
        video.addEventListener("play", () => {
          //Check if the video is in the active slide
          const parent = video.closest(".splide__slide");
          if (!parent.classList.contains("is-active")) {
            this.pauseAllVideos(video);
          }

          const index = parseFloat(parent.getAttribute("data-slide-index"));
          this.splide.go(index);
        });
      });
    });
  }

  onSlideMove(newIndex) {
    const relatedContent = this.querySelectorAll(".js-slide-content");
    if (relatedContent.length) {
      relatedContent.forEach((content) => {
        if (parseFloat(content.getAttribute("data-slide-index")) !== newIndex) {
          content.classList.add("hidden");
        } else {
          content.classList.remove("hidden");
        }
      });
    }
  }

  pauseAllVideos(except) {
    // Pause all videos except the one passed as an argument
    const videos = this.querySelectorAll("video");
    if (videos.length) {
      videos.forEach((video) => {
        if (video !== except) {
          video.pause();
        }
      });
    }
  }
}

customElements.define("product-focus-block", ProductFocusBlock);
